// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1565":"10a136fc","6392":"b984105f","6712":"10a136fc"}[chunkId] + ".chunk.css";
};